export default {"src":"/_next/static/media/hand_money.d2180b83.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};